import { CompanyExtended, CreatePersonioAppRequest } from '@pxtra-client-lib-legacy/gen';
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../../lib/util';

export function usePersonioAppCreate(options = {}) {
  return useMutation({
    mutationFn: ({
      client_id,
      client_secret,
      company
    }: CreatePersonioAppRequest & {
      company: CompanyExtended['id'];
    }) =>
      apiClient.integrations.companiesPersonioCreate({
        parentCompany: company,
        requestBody: {
          client_id: client_id ?? '',
          client_secret: client_secret ?? ''
        }
      }),
    ...options
  });
}

export function usePersonioAppDelete(options = {}) {
  return useMutation({
    mutationFn: ({ company }: { company: string }) =>
      apiClient.integrations.companiesPersonioDeleteDestroy({
        parentCompany: company
      }),
    ...options
  });
}

export function useSyncPersonioCompensationTypes(options = {}) {
  return useMutation({
    mutationFn: ({ company }: { company: string }) =>
      apiClient.integrations.companiesPersonioSyncSalaryComponentsCreate({
        parentCompany: company
      }),
    ...options
  });
}
